export default {"src":"/_next/static/media/eye-off-icon.04755d2c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};